import { useState, useEffect } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { authService } from '../services/api';
import { useTranslation } from 'react-i18next';

function ResetPasswordPage() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const token = searchParams.get('token') || '';
    const email = searchParams.get('email') || '';

    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState('');
    const { t } = useTranslation();

    useEffect(() => {
        if (!token || !email) {
            setError(t('auth.errors.invalid_reset_link'));
        }
    }, [token, email, t]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (newPassword.length < 8) {
            setError(t('auth.errors.password_min_length'));
            return;
        }

        if (newPassword !== confirmPassword) {
            setError(t('auth.errors.passwords_no_match'));
            return;
        }

        setLoading(true);
        setError('');

        try {
            await authService.resetPassword(email, token, newPassword);
            setSuccess(true);
            setTimeout(() => navigate('/login'), 3000);
        } catch (err) {
            setError(t('auth.errors.reset_failed'));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-container">
            <div className="auth-card">
                <h1>{t('app.name')}</h1>
                <h2>{t('auth.reset_title')}</h2>

                {success ? (
                    <div>
                        <div className="success-message">
                            {t('auth.reset_success_redirect')}
                        </div>
                    </div>
                ) : (
                    <form onSubmit={handleSubmit}>
                        {error && <div className="error-message">{error}</div>}

                        <div className="form-group">
                            <label>{t('settings.new_password')}</label>
                            <input
                                type="password"
                                value={newPassword}
                                onChange={e => setNewPassword(e.target.value)}
                                placeholder={t('auth.placeholders.password_min')}
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label>{t('settings.confirm_password')}</label>
                            <input
                                type="password"
                                value={confirmPassword}
                                onChange={e => setConfirmPassword(e.target.value)}
                                placeholder={t('auth.placeholders.password_repeat')}
                                required
                            />
                        </div>

                        <button type="submit" disabled={loading || !token || !email}
                            className="btn-primary"
                            style={{ width: '100%', padding: '0.85rem', marginTop: '0.5rem' }}>
                            {loading ? t('auth.resetting') : t('auth.reset_password')}
                        </button>

                        <p className="auth-link">
                            <Link to="/login">{t('auth.back_to_login')}</Link>
                        </p>
                    </form>
                )}
            </div>
        </div>
    );
}

export default ResetPasswordPage;